export default "__VITE_ASSET__DtgZzxT7__"